import $ from "jquery";
var array_of_hights = [];
/* Loop over all wrapper elements */
$(".featured-post--image-top").each(function (index) {
	/* Find the height of all */
	var height = $(this).innerHeight();
	/* Psuh to arrau */
	array_of_hights.push(height);
});
/* Find the highest height */
var maxHeight = Math.max(...array_of_hights);
/* Aplply height to all children */
$(".featured-post__wrapper")
	.find(".featured-post--image-top")
	.height(maxHeight);

$(".suki-page-header-button a").on("click", function (e) {
	e.preventDefault();
	var target = $(this).attr("href");
	$("html, body").animate(
		{
			scrollTop: $(target).offset().top,
		},
		400
	);
});
$(".content-accordion__buttons a").on("click", function (e) {
	e.preventDefault();
	var target = $(this).attr("href");
	$("html, body").animate(
		{
			scrollTop: $(target).offset().top,
		},
		400
	);
});
